import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {get, map} from 'lodash';
import {Button} from 'ui-library';
import i18n from 'i18n';

import {getStatics} from 'config/app';

import {gotoPage, displayAlert} from 'modules/legacy/js/actions/app';
import DataStoreActions from 'modules/legacy/js/actions/dataStore';

import SocialAvatarInfluencer from 'modules/legacy/js/components/social-avatar-influencer';
import ConfirmParticipationDialog from 'modules/campaigns/influencer/containers/ConfirmParticipationDialog';

const DAY_IN_HOURS = 24;
const INSUFFICIENT_FUNDS_CODE = 'CAMPAIGNS::INSUFFICIENT_FUNDS';

function mapStateToProps({entities, app}) {
  const {SocialNetworkAccount} = entities;
  const {systemSettings} = app;
  const {currency} = systemSettings
  return {
    socialAccounts: SocialNetworkAccount, 
    currency
  };
}

class OpenCampaignParticipations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      selectedParticipation: null,
      showConfirmDialog: false
    };
  }

  onConfirmResponse = (err, data) => {
    this.setState({loading: false}, () => {
      if (data.code) return this.handleSpecificParticipationAcceptationError(data);
      const inviteId = get(data, 'id');

      if (err || !inviteId) return handleGenericParticipationAcceptationError();
      this.onSuccessfulCampaignJoin(data);
    });
  }

  handleSpecificParticipationAcceptationError = (res) => {
    const isInsufficientBudgetError = res.code === INSUFFICIENT_FUNDS_CODE;
    if (isInsufficientBudgetError) return this.onInsufficientBudgetError(res);

    const isRepeatedParticipationAttempt = /already\ participating/.test(res.message);
    if (isRepeatedParticipationAttempt) return this.onRepeatedParticipationAttempt()

    this.handleGenericParticipationAcceptationError();
  }

  onInsufficientBudgetError(res) {
    const {onInsufficientBudget} = this.props;

    if (!!onInsufficientBudget) onInsufficientBudget();

    displayAlert({
      type: 'error',
      title: i18n.get('DEFAULT_ERROR_TITLE'),
      message: res.message || i18n.get('INF_VOXEAR_OPEN_CAMPAIGN_CONFIRMATION_ERROR_MESSAGE')
    });
  }

  onRepeatedParticipationAttempt = () => {
    DataStoreActions.remove({
      modelName: 'OpenCampaign',
      id: this.props.campaign._id
    });

    displayAlert({
      type: 'error',
      title: i18n.get('DEFAULT_ERROR_TITLE'),
      message: i18n.get('INF_VOXEAR_OPEN_CAMPAIGN_REPEATED_PARTICIPATION_ERROR_ALERT_MESSAGE')
    });

    gotoPage('/voxear');
  }

  handleGenericParticipationAcceptationError = () => {
    displayAlert({
      type: 'error',
      title: i18n.get('DEFAULT_ERROR_TITLE'),
      message: i18n.get('INF_VOXEAR_OPEN_CAMPAIGN_PARTICIPATION_ACCEPTATION_ERROR_ALERT_MESSAGE')
    });
  }

  onSuccessfulCampaignJoin = (invite) => {
    const {campaign} = this.props;
    const {selectedParticipation} = this.state;

    displayAlert({
      type: 'success',
      title: i18n.get('INF_VOXEAR_OPEN_CAMPAIGN_CAMPAIGN_JOIN_SUCCESS_ALERT_TITLE'),
      message: i18n.get('INF_VOXEAR_OPEN_CAMPAIGN_CAMPAIGN_JOIN_SUCCESS_ALERT_MESSAGE')
    });

    gotoPage(`/voxear/${invite.id}`);

    DataStoreActions.remove({
      modelName: 'OpenCampaign',
      id: campaign._id
    });
  }

  toggleConfirmDialog = (participation) => {
    const {showConfirmDialog} = this.state;

    this.setState({
      selectedParticipation: participation,
      showConfirmDialog: !showConfirmDialog
    });
  }

  renderParticipation = (campaign, participation) => {
    const {postPrice, socialNetwork} = participation;
    const {currency} = this.props
    const networkInfo = campaign.socialNetworks[socialNetwork];
    const paymentAmount = postPrice * networkInfo.postLimit;
    const currencySuffix = get(currency,'suffix','');
    const totalPayment = i18n.getMoney({ amount: paymentAmount, currency: currencySuffix });

    return (
      <div
        data-uitest='vf-open-campaign-participations-item'
        className='vf-open-campaign-participations-item flex between-xs'
      >
        <SocialAvatarInfluencer socialAccount={this.parseParticipation(participation)} />

        <Button onClick={this.toggleConfirmDialog.bind(this, participation)} size='sm' color='primary'>
          {i18n.get('INF_VOXEAR_OPEN_CAMPAIGN_PARTICIPATE_BUTTON', {postPrice: i18n.getMoney(postPrice, currencySuffix)})}
        </Button>
      </div>
    );
  }

  renderConfirmDialog = () => {
    const {selectedParticipation, showConfirmDialog, loading} = this.state;
    const {socialAccounts, currency} = this.props;
    const currencySuffix = get(currency,'suffix','');
    const {socialNetworks} = getStatics();

    if (!showConfirmDialog) return null;

    const {campaign} = this.props;
    const socialAccount = get(socialAccounts, selectedParticipation.socialAccountId);
    const socialNetworkRequirements = campaign.socialNetworks[socialAccount.socialNetwork];

    const socialNetworkName = socialNetworks[socialAccount.type].name;
    const paymentAmount = i18n.getMoney({ amount: get(selectedParticipation, 'postPrice'), currency: currencySuffix });
    const postsStr = i18n.get('INF_VOXEAR_OPEN_PUBLICATIONS_PLURAL', {posts: selectedParticipation.postsLimit});

    const mechanics = i18n.getHTML('INF_VOXEAR_CAMPAIGN_BRIEF_DIALOG_POSTS_MECHANICS', {
      socialNetworkName,
      paymentAmount,
      postsStr,
      totalProducts: 0,
      username: socialAccount.username,
      brandName: campaign.brandName
    });

    return (
      <ConfirmParticipationDialog
        onAccept={this.onConfirmResponse}
        onClose={this.toggleConfirmDialog}
        disableAcceptButton={loading}
        disableCancelButton={loading}
        requirements={socialNetworkRequirements}
        participation={this.parseParticipation(selectedParticipation)}
        socialAccount={socialAccount}
        campaign={campaign}
        postPrice={get(selectedParticipation, 'postPrice')}
        influencerFee={get(selectedParticipation, 'influencerFee')}
        influencerPayment={get(selectedParticipation, 'payPerPost')}
      >
        {mechanics}
      </ConfirmParticipationDialog>
    );
  }

  parseParticipation = (participation) => {
    return Object.assign({}, participation, {
      _id: participation.socialAccountId,
      type: participation.socialNetwork
    });
  }

  render = () => {
    const {campaign, participations} = this.props;
    const daysToSendProposal = campaign.hoursToSendProposal / DAY_IN_HOURS;

    return (
      <div className='vf-open-campaign-participations'>
        <div className='vf-description padding-top-2x'>
          <h1 className='vf-font-normal'>
            {i18n.get('INF_VOXEAR_CAMPAIGN_BRIEF_PROPOSAL', {brandName: campaign.brandName})}
          </h1>

          <div className='vf-row no-margin padding-top-1x'>
            <div className='col-xs-8 no-padding'>
              <div className='vf-card'>
                <div className='margin-top-1x vf-font-bold text-align-left'>
                  {i18n.get('INF_VOXEAR_CAMPAIGN_BRIEF_DAYS_TO_SEND_PROPOSAL', { days: daysToSendProposal || 1 })}
                </div>
                <div className='vf-description flex flex-align-top'>
                  <div className='vf-description-title col-xs-3'>
                    {i18n.get('INF_VOXEAR_OPEN_CAMPAIGN_AVAILABLE_ACCOUNTS')}
                  </div>
                  <div className='col-xs-9'>
                    <ul className='vf-open-campaign-participations-list'>
                      {map(participations, (participation, index) => {
                        return (
                          <li key={index}>
                            {this.renderParticipation(campaign, participation)}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.renderConfirmDialog()}
      </div>
    );
  }
}

OpenCampaignParticipations.PropTypes = {
  campaign: PropTypes.object.isRequired,
  participations: PropTypes.array.isRequired,
  onInsufficientBudget: PropTypes.func,
  socialAccounts: PropTypes.object
};

export default connect(mapStateToProps)(OpenCampaignParticipations);
